export default __webpack_public_path__ + "static/media/jest.b58fe313.png";